import React from 'react';
import PropTypes, { number, string } from 'prop-types';
import { fromCents, numberWithCommas } from 'utils/helpers';
import { fieldNames, frequencies } from '../const';
import RadioBoxesWithInput from '../reusable/RadioBoxesWithInput';
import QuestionText from '../reusable/QuestionText';

const CentreLinkQuestion = ({ bankStatementGovernmentBenefits, selectedValue }) => {
  const { amount, frequency } = bankStatementGovernmentBenefits;

  const benefitsAmount = numberWithCommas(fromCents(amount));
  const benefitsFrequency = frequencies[frequency];
  const shouldShowTextInput = selectedValue === 'NO';
  const centreLinkOptions = [
    {
      title: 'followup.question.centreLink.yes',
      translationValues: { benefitsAmount, benefitsFrequency },
      value: 'YES',
    },
    {
      title: 'followup.question.centreLink.no',
      value: 'NO',
    },
  ];

  return (
    <div className="followup__question-container">

      <QuestionText
        textId="followup.question.centreLink"
        values={{ benefitsAmount, benefitsFrequency }}
      />

      <RadioBoxesWithInput
        fieldName={fieldNames.governmentBenefits}
        options={centreLinkOptions}
        shouldShowTextInput={shouldShowTextInput}
        textInputName={fieldNames.governmentBenefitsClarification}
        textInputTitleId="followup.question.centreLink.clarification"
      />
    </div>
  );
};

CentreLinkQuestion.propTypes = {
  bankStatementGovernmentBenefits: PropTypes.shape({
    amount: number,
    frequency: string,
  }),
  selectedValue: string,
};

export default CentreLinkQuestion;
